<template>
  <div class="CartFinishVisa">
    <div class="cart-calculator">
      <template v-if="mensaje == ''">
        <template v-if="!loading">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Resumen de su pedido XssD</span>
            <span class="badge badge-primary badge-pill">{{
              cartProducts.length
            }}</span>
          </h4>
          <div class="row">
            <div class="col-lg-6">
              <ul class="list-group mb-3">
                <li
                  class="list-group-item"
                  v-for="(item, index) in cartProducts"
                  :key="index"
                >
                  <div class="row">
                    <template v-if="item.subproduct.id_lote == 0">
                      <div
                        class="col-6 col-sm-4 margen-automatico"
                        style="text-align: left;"
                      >
                        <p>
                          <strong>{{ item.name_product_es }}</strong>
                        </p>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="col-6 col-sm-4 margen-automatico"
                        style="text-align: left;"
                      >
                        <p>
                          <strong>{{
                            item.name_product_es +
                              ' Lote: ' +
                              item.subproduct.lote_sku
                          }}</strong>
                        </p>
                      </div>
                    </template>

                    <div class="col-6 col-sm-4 margen-automatico">
                      <p>
                        {{ item.price_product | currency }} X
                        <span class="span-cantidad-calculator"
                          ><strong>{{ item.qty }} </strong></span
                        >
                      </p>
                    </div>
                    <div
                      class="col-12 col-sm-4 margen-automatico"
                      style="text-align: left;"
                    >
                      <p>
                        <strong
                          >{{
                            (item.price_product * item.qty) | currency
                          }}*</strong
                        >
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <small>*Los precios incluyen IGV</small>
              <hr />
            </div>

            <div class="col-lg-6">
              <ul class="list-group mb-3">
                <li class="list-group-item d-flex justify-content-between">
                  <span>Subtotal:</span>
                  {{ (totalValue - delivery_price_on_screen) | currency }}
                </li>
                <li class="list-group-item d-flex justify-content-between">
                  <span>Despacho:</span> {{ delivery_price_on_screen | currency }}
                </li>

                <li class="list-group-item">
                  <div class="row">
                    <div class="col-sm-4" style=" text-align: left;">
                      <span>Cupón de Descuento</span>
                    </div>
                    <div class="col-sm-8">
                      <div class="input-group mb-3">
                        <input
                          v-model="discountCode"
                          type="text"
                          class="form-control"
                          maxlength="500"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-primary"
                            @click="submitDiscountCode()"
                            type="button"
                          >
                            Enviar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  v-if="discountCodeResponse !== ''"
                  :class="{
                    'text-danger': isErrorResponse,
                    'text-success': !isErrorResponse,
                  }"
                  class="list-group-item d-flex justify-content-between"
                >
                  <strong>{{ discountCodeResponse }}</strong>
                </li>
                <li
                  v-if="isDiscountApplied"
                  class="list-group-item d-flex justify-content-between"
                >
                  <span><strong>Descuento:</strong></span>
                  <strong>{{ discountPercent }}%</strong>
                </li>

                <li class="list-group-item d-flex justify-content-between">
                  <span><strong>Total:</strong></span>
                  <strong>{{ totalValue | currency }}</strong>
                </li>

                <li class="list-group-item d-flex justify-content-between">
                  <span>Tipo de Comprobante</span>
                  <strong
                    ><select v-model="tipoCDP" name="" id="" class="form-control">
                      <option value="0">Seleccione</option>
                      <option value="1">Boleta</option>
                      <option value="2">Factura</option>
                    </select>
                  </strong>
                </li>
                <template v-if="tipoCDP == 2">
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;">
                        <span>RUC</span>
                      </div>
                      <div class="col-sm-10">
                        <strong
                          ><input
                            v-model="ruc"
                            maxlength="11"
                            class="form-control"
                        /></strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;">
                        <span>Razón Social</span>
                      </div>
                      <div class="col-sm-10">
                        <strong
                          ><input
                            v-model="razsoc"
                            type="text"
                            maxlength="300"
                            class="form-control"
                        /></strong>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="row">
                      <div class="col-sm-2" style=" text-align: left;">
                        <span>Dirección Fiscal</span>
                      </div>
                      <div class="col-sm-10">
                        <strong
                          ><input
                            v-model="facdir"
                            type="text"
                            maxlength="300"
                            class="form-control"
                        /></strong>
                      </div>
                    </div>
                  </li>
                </template>

                <iframe
                  name="dummyframe"
                  id="dummyframe"
                  style="display: none;"
                ></iframe>

                <li class="list-group-item d-flex justify-content-between">
                  <small
                    ><strong
                      ><input type="checkbox" id="checkbox" v-model="checked" />
                      He leido y estoy de acuerdo con las
                      <router-link to="/guia/7" target="_blank"
                        >Terminos y Condiciones</router-link
                      >
                      de IFF.</strong
                    ></small
                  >
                </li>

                <template v-if="cartProducts.length > 0">
                  <template v-if="general_allowed_sale == true">
                    <template v-if="general_allowed_tpv == true">
                      <!--  <button class="btn btn-primary mt-2 text-white" :disabled="checked === false  || tipoCDP==0 || (tipoCDP==2 && (ruc.length != 11 || razsoc=='' || facdir==''))"  v-on:click="pagar()">Pasar a pagar con tarjeta(culqi)</button> -->
                      <button
                        class="btn btn-primary mt-2 text-white"
                        :disabled="
                          checked === false ||
                            tipoCDP == 0 ||
                            (tipoCDP == 2 &&
                              (ruc.length != 11 || razsoc == '' || facdir == ''))
                        "
                        v-on:click="pagar_niubiz()"
                      >
                        Pasar a pagar con tarjeta(Niubiz)
                      </button>
                      <button
                        class="btn btn-primary mt-2 text-white"
                        :disabled="
                          checked === false ||
                            tipoCDP == 0 ||
                            (tipoCDP == 2 &&
                              (ruc.length != 11 || razsoc == '' || facdir == ''))
                        "
                        data-toggle="modal"
                        data-target="#myModalPagoLink"
                      >
                        Pagar con Pago Link(Niubiz)
                      </button>
                      <button
                        class="btn btn-primary mt-2 text-white"
                        :disabled="
                          checked === false ||
                            tipoCDP == 0 ||
                            (tipoCDP == 2 &&
                              (ruc.length != 11 || razsoc == '' || facdir == ''))
                        "
                        data-toggle="modal"
                        data-target="#myModalCashPay"
                      >
                        Pago con Deposito o Transferencia
                      </button>
                    </template>
                  </template>
                  <template v-else>
                    <small style="color:#dc3545;"
                      >Uno o varios de los productos seleccioandos no se
                      encuentran habilitados para el pedido o venta online. Agrege
                      solamente productos habilitados.</small
                    >
                  </template>
                </template>

                <div
                  class="modal fade"
                  id="myModalCashPay"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalCashPay"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <button
                        type="button"
                        class="btn-close-modern"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>

                      <div class="modal-body">
                        <template v-if="steps_cash_pay == 1">
                          <h4><strong>Depósitos en efectivo</strong></h4>
                          <p>
                            Paga en cualquier agencia o agente autorizado del BCP
                            o BBVA a nivel nacional a la cuenta de Frutarom
                          </p>
                          <h4><strong>Transferencias bancarias</strong></h4>
                          <p>
                            Transfiere desde la banca por Internet o banca movíl a
                            las siguientes cuentas bancarias.
                          </p>
                          <br />
                          <button
                            class="btn btn-primary"
                            @click="steps_cash_pay = 2"
                          >
                            Siguiente
                          </button>
                        </template>
                        <template v-if="steps_cash_pay == 2">
                          <h4>Ahora debes realizar el pago de:</h4>
                          <br />
                          <h2>
                            <span style="color: blue;"
                              ><strong>{{ totalValue | currency }}</strong></span
                            >
                          </h2>
                          <br />
                          <h4>
                            <strong
                              >En nuestra cuenta recaudadora en Soles</strong
                            >
                          </h4>
                          <br />

                          <div class="row">
                            <!--
                  <div class="col-12">
                 
                    <div class="row">
                      <div class="col-8" style="text-align: left;"><strong>BCP:</strong> 194-2168618-0-30</div>
                      <div class="col-4"><button class="btn-sm btn-secondary" type="button" v-clipboard:copy="'194-2168618-0-30'"><i class="fa fa-copy"></i><small> Copiar</small></button></div>
                    </div>
                     <div class="row">
                      <div class="col-8" style="text-align: left;"><strong>BCP (CCI):</strong> 002-194-002168618030-94</div> 
                      <div class="col-4"><button class="btn-sm btn-secondary" type="button" v-clipboard:copy="'002-194-002168618030-94'"><i class="fa fa-copy"></i><small> Copiar</small></button></div>
                    </div>
                    <br>
                 
                  </div>
                   -->
                            <template v-for="(item, index) in banks_array">
                              <div class="col-12" :key="index">
                                <p>
                                  <strong
                                    >Pago de Servicios
                                    {{ item.method_description_es }}</strong
                                  >
                                </p>
                                <div class="row">
                                  <div class="col-8" style="text-align: left;">
                                    <strong
                                      >{{ item.method_description_es }}:</strong
                                    >
                                    {{ item.method_detail }}
                                  </div>
                                  <div class="col-4">
                                    <button
                                      class="btn-sm btn-secondary"
                                      type="button"
                                      v-clipboard:copy="item.method_detail"
                                    >
                                      <i class="fa fa-copy"></i
                                      ><small> Copiar</small>
                                    </button>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-8" style="text-align: left;">
                                    <strong
                                      >{{
                                        item.method_description_es
                                      }}
                                      (CCI):</strong
                                    >
                                    {{ item.second_method_detail }}
                                  </div>
                                  <div class="col-4">
                                    <button
                                      class="btn-sm btn-secondary"
                                      type="button"
                                      v-clipboard:copy="item.second_method_detail"
                                    >
                                      <i class="fa fa-copy"></i
                                      ><small> Copiar</small>
                                    </button>
                                  </div>
                                </div>
                                <br />
                              </div>
                            </template>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-8" style="text-align: left;">
                                  <strong>Info.peru@iff.com</strong>
                                </div>
                                <div class="col-4">
                                  <button
                                    class="btn-sm btn-secondary"
                                    type="button"
                                    v-clipboard:copy="'Info.peru@iff.com'"
                                  >
                                    <i class="fa fa-copy"></i
                                    ><small> Copiar</small>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <br />
                            <br />
                            <div class="col-12">
                              <small
                                >Todo pedido con depósito interbancario se confirmará hasta en 48 horas. Le recordamos que si ha seleccionado su despacho o retiro en tienda menor a 48 horas este tendrá una reprogramación dependiendo de la confirmación del depósito.</small
                              >
                            </div>
                          </div>
                          <br />
                          <button
                            class="btn btn-primary"
                            @click="steps_cash_pay = 3"
                          >
                            Siguiente
                          </button>
                        </template>
                        <template v-if="steps_cash_pay == 3">
                          <h4>
                            <strong>¿Ya depositaste o transferiste?</strong>
                          </h4>
                          <br />
                          <div class="modal-footer">
                            <button
                              class="btn btn-primary"
                              @click="steps_cash_pay = 4"
                              data-dismiss="modal"
                            >
                              Si, continuar
                            </button>
                            <button
                              class="btn btn-primary"
                              @click="steps_cash_pay = 1"
                            >
                              Cancelar Operaciones
                            </button>
                          </div>
                        </template>
                        <template v-if="steps_cash_pay == 4">
                          <h4>
                            <strong>{{ client_name }}</strong
                            >, elige como deseas confirmar tu transferencia:
                          </h4>
                          <br />
                          <input
                            type="radio"
                            id="uno"
                            value="Uno"
                            v-model="picked"
                          />
                          <label for="uno">Número de Operación Bancaria:</label>
                          <br />
                          <template v-if="picked == 'Uno'">
                            <p>
                              Envía el número de operación del depósito o la
                              transferencia proporcionado por tu banco
                            </p>
                            <br />
                            <form>
                              <div class="form-group">
                                <input
                                  class="form-control"
                                  v-model="operation_number"
                                  type="text"
                                  placeholder="Número de operación"
                                  required
                                />
                              </div>

                              <div class="form-group">
                                <input
                                  class="form-control"
                                  id="voucherFile"
                                  type="file"
                                  placeholder="Adjuntar voucher"
                                  required
                                  @change="file_confirmtion = true"
                                  accept="application/pdf, image/png, .jpeg, .jpg, .JEPG"
                                />
                                <small style="color:grey;"
                                  ><i
                                    >"Solo se aceptan comprobantes en formato .jpg
                                    y .pdf"</i
                                  ></small
                                >
                              </div>
                              <div class="form-group">
                                <select
                                  class="form-control"
                                  v-model="origin_bank"
                                  id="exampleFormControlSelect1"
                                  required
                                >
                                  <option value="" selected
                                    >Seleccione Banco de Origen</option
                                  >
                                  <option value="ScotiaBank">ScotiaBank</option>
                                  <option value="Interbank">Interbank</option>
                                  <option value="BCP">BCP</option>
                                  <option value="BBVA">BBVA</option>
                                  <option value="Otro">Otro</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <select
                                  class="form-control"
                                  v-model="destiny_bank"
                                  id="exampleFormControlSelect2"
                                  required
                                >
                                  <option value="" selected
                                    >Seleccione Banco de Destino</option
                                  >
                                  <template v-for="(item, index) in banks_array">
                                    <option
                                      :key="index"
                                      :value="
                                        'IFF ' +
                                          item.method_description_es +
                                          ': ' +
                                          item.method_detail
                                      "
                                      >{{
                                        'IFF ' +
                                          item.method_description_es +
                                          ': ' +
                                          item.method_detail
                                      }}</option
                                    >
                                  </template>
                                </select>
                              </div>
                            </form>
                          </template>

                          <br />
                          <input
                            type="radio"
                            id="Dos"
                            value="Dos"
                            v-model="picked"
                          />
                          <label for="Dos"
                            >Enviar constancia por correo electrónico</label
                          >
                          <br />

                          <template v-if="picked == 'Dos'">
                            <p>
                              Envía la constancia de tu transferencia o depósito
                              a:
                            </p>
                            <p>
                              <strong>info.peru@iff.com </strong>
                              <button
                                class="btn-sm btn-secondary"
                                type="button"
                                v-clipboard:copy="'Info.peru@iff.com'"
                              >
                                <i class="fa fa-copy"></i><small> Copiar</small>
                              </button>
                            </p>
                          </template>

                          <br />
                          <div class="modal-footer">
                            <div class="row">
                              <div class="col-sm-12">
                                <template v-if="picked == ''">
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    disabled
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                                <template v-else-if="picked == 'Uno'">
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    :disabled="
                                      operation_number == '' ||
                                      !file_confirmtion ||
                                      origin_bank == '' ||
                                      destiny_bank == ''
                                        ? true
                                        : false
                                    "
                                    @click="islogged(1)"
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    @click="islogged(1)"
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                              </div>
                              <div class="col-sm-12">
                                <br />
                              </div>
                              <div class="col-sm-12">
                                <button
                                  class="btn btn-primary btn-ancho-total"
                                  @click="steps_cash_pay = 1"
                                  data-dismiss="modal"
                                >
                                  Cancelar Operaciones
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="modal fade"
                  id="myModalPagoLink"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="myModalPagoLinkLabel"
                >
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content modal-pagolink">
                      <button
                        type="button"
                        class="btn-close-modern"
                        data-dismiss="modal"
                        aria-label="Cerrar"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>

                      <div class="modal-body">
                        <template v-if="steps_cash_pay_pagolink == 1">
                          <h4 id="myModalPagoLinkLabel">
                            <strong>Pagar con pago link (NIUBIZ)</strong>
                          </h4>
                          <br />
                          <h2>
                            <span style="color: blue;"
                              ><strong>{{ totalValue | currency }}</strong></span
                            >
                          </h2>
                          <br />
                          <p>
                            Utiliza "Pago Link" para realizar tu pago de
                            {{ totalValue | currency }} con el siguiente enlace:
                          </p>
                          <br />
                          <div class="pagolink-url-box">
                            <a
                              class="pagolink-url"
                              href="https://pagolink.niubiz.com.pe/pagoseguro/FRUTAROM/286345/info"
                              target="_blank"
                              rel="noopener noreferrer"
                              >https://pagolink.niubiz.com.pe/pagoseguro/FRUTAROM/286345/info</a
                            >
                            <button
                              class="btn btn-sm btn-outline-secondary pagolink-copy"
                              type="button"
                              v-clipboard:copy="
                                'https://pagolink.niubiz.com.pe/pagoseguro/FRUTAROM/286345/info'
                              "
                              v-clipboard:success="onPagolinkCopied"
                              @click="onPagolinkCopied"
                            >
                              <i class="fa fa-copy"></i
                              ><small>{{
                                pagolinkCopied ? ' Copiado' : ' Copiar'
                              }}</small>
                            </button>
                          </div>
                          <br />
                          <button
                            class="btn btn-primary"
                            :disabled="!pagolinkCopied"
                            @click="steps_cash_pay_pagolink = 2"
                          >
                            Siguiente
                          </button>
                        </template>

                        <template v-if="steps_cash_pay_pagolink == 2">
                          <h4><strong>¿Ya realizaste el pago?</strong></h4>
                          <br />
                          <div class="modal-footer">
                            <button
                              class="btn btn-primary"
                              @click="steps_cash_pay_pagolink = 3"
                              data-dismiss="modal"
                            >
                              Si, continuar
                            </button>
                            <button
                              class="btn btn-primary"
                              @click="goToPagolinkStep(1)"
                            >
                              Cancelar Operaciones
                            </button>
                          </div>
                        </template>
                        <template v-if="steps_cash_pay_pagolink == 3">
                          <h4>
                            <strong>{{ client_name }}</strong
                            >, elige como deseas confirmar tu pago:
                          </h4>
                          <br />
                          <input
                            type="radio"
                            id="uno"
                            value="Uno"
                            v-model="picked"
                          />
                          <label for="uno">Código de autorización:</label>
                          <br />
                          <template v-if="picked == 'Uno'">
                            <p>
                              Envía el código de autorización proporcionado por
                              pagolink
                            </p>
                            <br />
                            <form>
                              <div class="form-group">
                                <input
                                  class="form-control"
                                  v-model="operation_number"
                                  type="text"
                                  placeholder="Código de operación"
                                  required
                                />
                              </div>

                              <div class="form-group">
                                <input
                                  class="form-control"
                                  id="voucherFile"
                                  type="file"
                                  placeholder="Adjuntar voucher"
                                  required
                                  @change="file_confirmtion = true"
                                  accept="application/pdf, image/png, .jpeg, .jpg, .JEPG"
                                />
                                <small style="color:grey;"
                                  ><i
                                    >"Solo se aceptan comprobantes en formato .jpg
                                    y .pdf"</i
                                  ></small
                                >
                              </div>
                            </form>
                          </template>

                          <br />
                          <input
                            type="radio"
                            id="Dos"
                            value="Dos"
                            v-model="picked"
                          />
                          <label for="Dos"
                            >Enviar constancia por correo electrónico</label
                          >
                          <br />

                          <template v-if="picked == 'Dos'">
                            <p>Envía la constancia de tu pago a:</p>
                            <p>
                              <strong>info.peru@iff.com </strong>
                              <button
                                class="btn-sm btn-secondary"
                                type="button"
                                v-clipboard:copy="'Info.peru@iff.com'"
                              >
                                <i class="fa fa-copy"></i><small> Copiar</small>
                              </button>
                            </p>
                          </template>

                          <br />
                          <div class="modal-footer">
                            <div class="row">
                              <div class="col-sm-12">
                                <template v-if="picked == ''">
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    disabled
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                                <template v-else-if="picked == 'Uno'">
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    :disabled="
                                      operation_number == '' || !file_confirmtion
                                        ? true
                                        : false
                                    "
                                    @click="islogged(2)"
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                    class="btn btn-primary btn-ancho-total"
                                    @click="islogged(2)"
                                    data-dismiss="modal"
                                  >
                                    Confirmar
                                  </button>
                                </template>
                              </div>
                              <div class="col-sm-12">
                                <br />
                              </div>
                              <div class="col-sm-12">
                                <button
                                  class="btn btn-primary btn-ancho-total"
                                  @click="goToPagolinkStep(1)"
                                  data-dismiss="modal"
                                >
                                  Cancelar Operaciones
                                </button>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!--<router-link to="/payment" class="btn btn-danger mt-2 text-white">Checkout</router-link>-->
              </ul>
            </div>
          </div>
        </template>
        <template v-else-if="loading == true">
          <li class="list-group-item">
            <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
            <template v-if="general_allowed_tpv == true">
              <p>Estamos procesando su compra. Por favor, espere.</p>
            </template>
            <template v-else>
              <p>Estamos procesando su pedido. Por favor, espere.</p>
            </template>
          </li>
        </template>
      </template>

      <div
        :class="[mensaje === '' ? 'd-none' : 'alert alert-success']"
        role="alert"
      >
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          @click="ocultar()"
        >
          &times;</button
        ><strong
          >{{ mensaje }}<router-link to="/pedidos">aquí</router-link>.</strong
        >
      </div>
      <div
        :class="[mensaje_error === '' ? 'd-none' : 'alert alert-danger']"
        role="alert"
      >
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          @click="ocultar()"
        >
          &times;</button
        ><strong><span v-html="mensaje_error"></span></strong>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { mapState, mapActions, mapMutations } from 'vuex';
import { config_settings } from '../../../../config.js';
import axios from 'axios';
import {
  successToaster,
  errorToaster,
} from '../../../../components/shared/service/ErrorHandler.js';
import _ from 'lodash';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

Culqi.publicKey = 'pk_test_cZJm1j7hvWp5lmPt';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;
const BAD_GATEWAY = 502;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.log(error);
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error(
          'Usted no tiene los provilegios para acceder a esta sección',
          'ERROR',
          {
            iconClass: 'customer-danger',
          },
        );
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'cartFinishVisa',
  data() {
    return {
      json_cliente: '',
      checked: false,
      userdata: false,
      loading: false,
      tokenID: '',
      totalValue: 0.0,
      products_data: [],
      general_allowed_sale: true,
      general_allowed_tpv: true,
      mensaje: '',
      mensaje_error: '',
      showLoader: false,
      client_email: '',
      client_username: '',
      client_name: '',
      client_lastname: '',
      client_dni: '',
      cliente_phone: '',
      cboDepartamento: '',
      cboProvincia: '',
      cboDistrito: '',
      client_address: '',
      cboDepartamento: '',
      depas_array: [],
      province_array: [],
      distrito_array: [],
      isdisabled: true,
      isdisabled_distrito: true,
      isErrorResponse: false,
      isDiscountApplied: false,
      discountCode: '',
      discountPercent: 0,
      discountCodeResponse: '',
      isdisabled_direccion: true,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      tipoCDP: '0',
      razsoc: '',
      ruc: '',
      facdir: '',
      mail_confirm: false,
      operation_number: '',
      origin_bank: '',
      destiny_bank: '',
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      id_delivery: localStorage.getItem('id_delivery'),
      day_delivery: localStorage.getItem('day_delivery'),
      ruc_agency: localStorage.getItem('ruc_agency'),
      dir_agency: localStorage.getItem('dir_agency'),
      delivery_price_on_screen: JSON.parse(
        localStorage.getItem('price_delivery'),
      ),
      address_details: JSON.parse(localStorage.getItem('address_details')),
      transport_address_details: JSON.parse(
        localStorage.getItem('transport_address_details'),
      ),
      delivery_detail: '',
      gen_delivery_cost: 0.0,
      visa_token: '',
      visa_sesion_id: '',
      term: '',
      steps_cash_pay: 1,
      steps_cash_pay_pagolink: 1,
      pagolinkCopied: false,
      picked: '',
      operation_number: '',

      banks_array: [],

      file_confirmtion: false,
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    onPagolinkCopied() {
      this.pagolinkCopied = true;
    },

    goToPagolinkStep(step) {
      this.steps_cash_pay_pagolink = step;
      if (step === 1) {
        this.pagolinkCopied = false;
      }
    },

    analizeCart() {
      let actual_total = 0.0;
      //var delivery = this.delivery_detail.delivery_cost;
      this.general_allowed_sale = true;
      this.cartProducts.forEach((product, index) => {
        if (product.allowed_sale == false) {
          this.general_allowed_sale = false;
        }
        if (product.allowed_tpv == false) {
          this.general_allowed_tpv = false;
        }
        console.log('precio del delivery ' + this.gen_delivery_cost);
        var subtotal =
          (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
        //actual_total = actual_total ;
      });
      //this.totalValue = Math.round((actual_total + this.gen_delivery_cost)*100)/100;
      this.totalValue =
        Math.round((actual_total + this.delivery_price_on_screen) * 100) / 100;
    },

    createAccount_erp(new_json_data) {
      console.log('Este json se enviará:' + JSON.stringify(new_json_data));

      axios({
        method: 'post',
        url:
          'https://zonasegura.frutaromla.com/frutarom_apitv/api/cliente/registrar',
        data: new_json_data,
      })
        .then(response => {
          console.log('Usuario registrado correctamente en ERP!');
        })
        .catch(error => {
          //console.log("Surgio un error" + error.response.data.errorCode);
          this.mensaje_error =
            'ATENCIÓN: Se presentó un error en el envio de información al ERP.';
        });
    },

    refreshToken() {
      var refresh_token = localStorage.getItem('refresh_token');
      var refresh_credentials = new FormData();
      refresh_credentials.append('grant_type', 'refresh_token');
      refresh_credentials.append('refresh_token', refresh_token);
      refresh_credentials.append('id_store', config_settings.STORE);

      const refreshingCall = axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: refresh_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password',
        },
      }).then(response => {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    get_puser_data() {
      this.userdata = false;
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log('responde todo');

          this.userdata = true;
          this.client_email = response.data.email_client;
          this.client_username = response.data.nick_client;
          this.client_name = response.data.name_client;
          this.client_lastname = response.data.surname_client;
          this.client_dni = response.data.dni_client;
          this.cliente_phone = response.data.phone_client;
          this.client_address = response.data.address_client;

          var cboDistrito = response.data.id_district.id_district;
          if (cboDistrito != 0) {
            this.cboDistrito = response.data.id_district.id_district;
          } else {
            this.cboDistrito = '';
          }
          console.log('responde todo' + this.userdata);

          this.json_cliente = response.data;
        })
        .catch(error => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.get_puser_data();
              })
              .catch(_ => {
                this.userdata = false;
              });
          } else {
            this.userdata = false;
            toastr.error(
              error.response.data.details,
              error.response.data.message,
              {
                iconClass: 'customer-danger',
              },
            );
          }
        });
    },

    get_delivery_detail() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/deliverys/' +
            this.id_delivery,
        )
        .then(response => {
          this.delivery_detail = response.data;
          console.log('DETALLE ' + JSON.stringify(this.delivery_detail));
          this.gen_delivery_cost = this.delivery_detail.delivery_cost;

          console.log('COSTO:' + this.gen_delivery_cost);
          this.analizeCart();
        })
        .catch(error => {
          console.log(error);
        });
    },

    submitDiscountCode() {
      this.discountCodeResponse = 'Su cupón de descuento no es válido';
      const discountCode = this.discountCode;

      axios({
        method: 'post',
        url:
          config_settings.RESOURCE_SERVER_URL +
          '/POST/couponsxpromocodexdates/' +
          discountCode,
      })
        .then(response => {
          this.discountCodeResponse = `Código de descuento ${
            response.data.promo_code
          } aplicado exitosamente.`;
          this.discountPercent = response.data.discount_percent;
          this.isErrorResponse = false;
          this.isDiscountApplied = true;
          this.calculateTotal();
        })
        .catch(error => {
          if (error.response && error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(() => {
                this.submitDiscountCode();
              })
              .catch(() => {
                // Manejo de error al refrescar token
              });
          } else {
            this.discountCodeResponse =
              'Código de descuento ingresado no es válido.';
            this.discountPercent = 0;
            this.isErrorResponse = true;
            this.isDiscountApplied = false;
            this.calculateTotal();
          }
        });
    },
    calculateTotal() {
      let subtotal = this.cartProducts.reduce((sum, item) => {
        return sum + item.price_product * item.qty;
      }, 0);
      const discountValue = (subtotal * this.discountPercent) / 100;
      const discountedSubtotal = subtotal - discountValue;
      this.totalValue = discountedSubtotal + this.delivery_price_on_screen;
    },

    get_delivery_detail_xdistrict(district) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/deliverys/' +
            this.id_delivery +
            '/district/' +
            district,
        )
        .then(response => {
          this.delivery_detail = response.data;
          console.log('DETALLE ' + JSON.stringify(this.delivery_detail));
          this.gen_delivery_cost = this.delivery_detail.delivery_cost;
          console.log('COSTO:' + this.gen_delivery_cost);
          this.analizeCart();
        })
        .catch(error => {
          console.log(error);
        });
    },

    islogged(operation_type) {
      this.steps_cash_pay = 1;
      this.steps_cash_pay_pagolink = 1;
      this.pagolinkCopied = false;
      if (this.userdata == true) {
        if (
          this.client_dni == null ||
          this.cliente_phone == null ||
          this.cboDistrito == '' ||
          this.client_address == ''
        ) {
          this.mensaje = '';
          this.mensaje_error =
            "Debe ingresar sus datos completos para poder realizar un pedido. Actualize todos sus datos <a href='/perfil'>aquí</a> e inténtelo nuevamente.";
        } else {
          if (operation_type == 1) {
            this.generate_charge_efectivo();
          } else if (operation_type == 2) {
            this.generate_charge_pago_link();
          }
        }
      } else {
        toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
          iconClass: 'customer-danger',
        });
        this.mensaje_error = 'Debe iniciar sesión antes de continuar';
        this.mensaje = '';
        this.$router.push({ path: '../../login/' });
      }
    },

    pagar() {
      if (this.userdata == true) {
        if (
          this.client_dni == null ||
          this.cliente_phone == null ||
          this.cboDistrito == '' ||
          this.client_address == ''
        ) {
          this.mensaje = '';
          this.mensaje_error =
            "Debe ingresar sus datos completos para poder realizar una compra. Actualize todos sus datos <a href='/perfil'>aquí</a> e inténtelo nuevamente.";
        } else {
          this.openCulqiForm();
          //this.openVisanet();
        }
      } else {
        toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
          iconClass: 'customer-danger',
        });
        this.mensaje_error = 'Debe iniciar sesión antes de continuar';
        this.mensaje = '';
        this.$router.push({ path: '../../login/' });
      }
    },

    pagar_niubiz() {
      if (this.userdata == true) {
        if (
          this.client_dni == null ||
          this.cliente_phone == null ||
          this.cboDistrito == '' ||
          this.client_address == ''
        ) {
          this.mensaje = '';
          this.mensaje_error =
            "Debe ingresar sus datos completos para poder realizar una compra. Actualize todos sus datos <a href='/perfil'>aquí</a> e inténtelo nuevamente.";
        } else {
          if (this.tipoCDP == 1) {
            var json_cdp = {
              factura: false,
              ruc: '',
              companyName: '',
              billing_address: '',
            };
          } else {
            var json_cdp = {
              factura: true,
              ruc: this.ruc,
              companyName: this.razsoc,
              billing_address: this.facdir,
            };
          }

          localStorage.setItem(
            'cdp_details_for_visanet',
            JSON.stringify(json_cdp),
          );
          this.visanetGetToken();
          //this.visanetGetSesionid();
          //this.openVisanet();
        }
      } else {
        toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
          iconClass: 'customer-danger',
        });
        this.mensaje_error = 'Debe iniciar sesión antes de continuar';
        this.mensaje = '';
        this.$router.push({ path: '../../login/' });
      }
    },

    openCulqiForm() {
      //verificar si el cliente tiene todos los datos completos antes de habilitar la pasarela de pagos

      //this.get_puser_data();
      console.log('Valor total' + this.totalValue);

      Culqi.settings({
        title: 'Proceso de Pago',
        currency: 'PEN',
        description:
          'Ingrese los datos de su tarjeta de crédito o débito para continuar',
        amount: this.totalValue * 100,
      });

      Culqi.open();
    },

    openVisanet() {
      this.get_puser_data();
      console.log('Valor total' + this.totalValue);
      var sesion_id = this.visa_sesion_id;
      var amount_total = this.totalValue;
      var result = '';
      var name = this.client_name;
      var last_name = this.client_lastname;
      var email_niubiz = this.client_email;
      var token_substrack = this.visa_token.replace(/\D/g, '').slice(-12);
      console.log('Ver el token: ', this.visa_token);
      console.log('Ver el token: ', token_substrack);

      console.log(token_substrack);
      VisanetCheckout.configure({
        sessiontoken: sesion_id,
        channel: 'web',
        //merchantid: '456879852',
        merchantname: 'IFF Perú',
        merchantid: '650178888',
        formbuttoncolor: '#007bff',
        purchasenumber: token_substrack,
        amount: amount_total,
        cardholdername: name,
        cardholderlastname: last_name,
        expirationminutes: '8',
        cardholderemail: email_niubiz,
        //timeouturl: 'timeout.html',
        timeouturl: 'https://www.iffvirtual.pe/timeout',
        //usertoken: 'token123456',
        //usertoken:  this.token.substr(0,11),
        //action: 'javascript:;',
        //action: 'http://localhost/visaphp/visa.php',
        //action: 'http://18.237.166.9/visaphp/visa.php',
        action: 'https://www.iffvirtual.pe/visaphp/visa.php',
        complete: function(params) {
          alert(JSON.stringify(params));
        },
      });
      VisanetCheckout.open();
    },

    generate_charge_efectivo() {
      this.loading = true;

      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });

      var json_data = '';

      if (this.picked == 'Uno') {
        this.mail_confirm = true;
      } else if (this.picked == 'Dos') {
        this.mail_confirm = false;
      }

      if (this.tipoCDP == 1) {
        json_data = {
          sales_detail: this.products_data,
          factura: false,
          mail_confirm: this.mail_confirm,
          operation_number: this.operation_number,
          origin_bank: this.origin_bank,
          destiny_bank: this.destiny_bank,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo: !this.address_details
              ? ''
              : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion: !this.address_details
              ? ''
              : this.address_details.address +
                ', ' +
                this.address_details.id_district.desc_district +
                ', ' +
                this.address_details.id_district.province.desc_province +
                ', ' +
                this.address_details.id_district.province.departament
                  .desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: !this.address_details
              ? ''
              : this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.json_cliente.dni_client,
          "nombre": this.json_cliente.surname_client + " " + this.json_cliente.name_client,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 1,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      } else if (this.tipoCDP == 2) {
        json_data = {
          sales_detail: this.products_data,
          factura: true,
          ruc: this.ruc,
          companyName: this.razsoc,
          billing_address: this.facdir,
          mail_confirm: this.mail_confirm,
          operation_number: this.operation_number,
          origin_bank: this.origin_bank,
          destiny_bank: this.destiny_bank,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo: !this.address_details
              ? ''
              : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion: !this.address_details
              ? ''
              : this.address_details.address +
                ', ' +
                this.address_details.id_district.desc_district +
                ', ' +
                this.address_details.id_district.province.desc_province +
                ', ' +
                this.address_details.id_district.province.departament
                  .desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: !this.address_details
              ? ''
              : this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.ruc,
          "nombre": this.razsoc,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 6,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      }

      console.log('Aqui igual');
      console.log(JSON.stringify(json_data));

      var formData = new FormData();
      if (this.mail_confirm) {
        formData.append(
          'file',
          document.getElementById('voucherFile').files[0],
        );
      } else {
        formData.append('file', new File([''], 'filename'));
      }

      formData.append(
        'chargeData',
        new Blob([JSON.stringify(json_data)], { type: 'application/json' }),
      );

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-cashpay',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log(response.data);
          this.loading = false;
          this.removeAllProductCart();
          this.mensaje =
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ';
          this.mensaje_error = '';
          this.file_confirmtion = false;
        })
        .catch(error => {
          this.loading = false;
          this.file_confirmtion = false;
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.generate_charge_efectivo();
              })
              .catch(_ => {
                toastr.error(
                  'Debe iniciar sesión antes de continuar',
                  'Error',
                  {
                    iconClass: 'customer-danger',
                  },
                );
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_GATEWAY) {
            console.log(error.response.data.details);
            this.removeAllProductCart();
            this.mensaje =
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.mensaje_error = '';
          } else {
            console.log(error.response.data);
            this.mensaje = '';
            //this.mensaje_error = error.response.data.details
            this.mensaje_error =
              'Estimado cliente le informamos que no contamos con stock del producto solicitado, es posible que recientemente se haya agotado.';
          }
        });
    },

    generate_charge_pago_link() {
      this.loading = true;

      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });

      var json_data = '';

      if (this.picked == 'Uno') {
        this.mail_confirm = true;
      } else if (this.picked == 'Dos') {
        this.mail_confirm = false;
      }

      if (this.tipoCDP == 1) {
        json_data = {
          sales_detail: this.products_data,
          factura: false,
          mail_confirm: this.mail_confirm,
          operation_number: this.operation_number,
          origin_bank: '',
          destiny_bank: '',
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo:
              this.address_details.id_district.cod_ubigeo == null
                ? ''
                : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion:
              this.address_details.address +
              ', ' +
              this.address_details.id_district.desc_district +
              ', ' +
              this.address_details.id_district.province.desc_province +
              ', ' +
              this.address_details.id_district.province.departament
                .desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.json_cliente.dni_client,
          "nombre": this.json_cliente.surname_client + " " + this.json_cliente.name_client,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 1,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      } else if (this.tipoCDP == 2) {
        json_data = {
          sales_detail: this.products_data,
          factura: true,
          ruc: this.ruc,
          companyName: this.razsoc,
          billing_address: this.facdir,
          mail_confirm: this.mail_confirm,
          operation_number: this.operation_number,
          origin_bank: '',
          destiny_bank: '',
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo:
              this.address_details.id_district.cod_ubigeo == null
                ? ''
                : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion:
              this.address_details.address +
              ', ' +
              this.address_details.id_district.desc_district +
              ', ' +
              this.address_details.id_district.province.desc_province +
              ', ' +
              this.address_details.id_district.province.departament
                .desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.ruc,
          "nombre": this.razsoc,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 6,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      }

      console.log('Aqui igual');
      console.log(JSON.stringify(json_data));

      var formData = new FormData();
      if (this.mail_confirm) {
        formData.append(
          'file',
          document.getElementById('voucherFile').files[0],
        );
      } else {
        formData.append('file', new File([''], 'filename'));
      }

      formData.append(
        'chargeData',
        new Blob([JSON.stringify(json_data)], { type: 'application/json' }),
      );

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-pagolink',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log(response.data);
          this.loading = false;
          this.removeAllProductCart();
          this.mensaje =
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ';
          this.mensaje_error = '';
          this.file_confirmtion = false;
        })
        .catch(error => {
          this.loading = false;
          this.file_confirmtion = false;
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.generate_charge_pago_link();
              })
              .catch(_ => {
                toastr.error(
                  'Debe iniciar sesión antes de continuar',
                  'Error',
                  {
                    iconClass: 'customer-danger',
                  },
                );
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_GATEWAY) {
            console.log(error.response.data.details);
            this.removeAllProductCart();
            this.mensaje =
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.mensaje_error = '';
          } else {
            console.log(error.response.data);
            this.mensaje = '';
            //this.mensaje_error = error.response.data.details
            this.mensaje_error =
              'Estimado cliente le informamos que no contamos con stock del producto solicitado, es posible que recientemente se haya agotado.';
          }
        });
    },

    generate_charge(tokenID, email) {
      this.loading = true;

      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });

      var json_data = '';

      if (this.tipoCDP == 1) {
        json_data = {
          tokenID: tokenID,
          email: email,
          sales_detail: this.products_data,
          factura: false,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo: '2312323',
            detalle_ubicacion: 'direccion',
            dia_entrega: this.day_delivery,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        var json_erp = {
          id: this.json_cliente.dni_client,
          nombre:
            this.json_cliente.surname_client +
            ' ' +
            this.json_cliente.name_client,
          evento: 'N',
          direccion: this.json_cliente.address_client,
          tipo_Documento: 1,
          moneda: 'SOL',
          email: this.json_cliente.email_client,
          telefono: this.json_cliente.phone_client,
          codigo_Vendedor: '151',
          codigo_Cobrador: '90',
          codigo_Sectorista: 'BAGUILAR',
          direccion_Embarque: this.json_cliente.address_client,
          ubigeo: '999999',
        };
        this.createAccount_erp(json_erp);
      } else if (this.tipoCDP == 2) {
        json_data = {
          tokenID: tokenID,
          email: email,
          sales_detail: this.products_data,
          factura: true,
          ruc: this.ruc,
          companyName: this.razsoc,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo: '2312323',
            detalle_ubicacion: 'direccion',
            dia_entrega: this.day_delivery,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == ''
                ? ''
                : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        var json_erp = {
          id: this.ruc,
          nombre: this.razsoc,
          evento: 'N',
          direccion: this.json_cliente.address_client,
          tipo_Documento: 6,
          moneda: 'SOL',
          email: this.json_cliente.email_client,
          telefono: this.json_cliente.phone_client,
          codigo_Vendedor: '151',
          codigo_Cobrador: '90',
          codigo_Sectorista: 'BAGUILAR',
          direccion_Embarque: this.json_cliente.address_client,
          ubigeo: '999999',
        };
        this.createAccount_erp(json_erp);
      }

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log(response.data);
          this.loading = false;
          this.removeAllProductCart();
          this.mensaje =
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ';
          this.mensaje_error = '';
        })
        .catch(error => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.generate_charge(tokenID, email);
              })
              .catch(_ => {
                toastr.error(
                  'Debe iniciar sesión antes de continuar',
                  'Error',
                  {
                    iconClass: 'customer-danger',
                  },
                );
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_GATEWAY) {
            console.log(error.response.data.details);
            this.loading = false;
            this.removeAllProductCart();
            this.mensaje =
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.mensaje_error = '';
          } else {
            console.log(error.response.data);
            this.mensaje = '';
            this.mensaje_error = error.response.data.details;
            this.loading = false;
          }
        });
    },

    generate_order() {
      this.loading = true;
      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
        };
      });

      var json_data = '';

      if (this.tipoCDP == 1) {
        json_data = {
          sales_detail: this.products_data,
          factura: false,
        };
      } else if (this.tipoCDP == 2) {
        json_data = {
          sales_detail: this.products_data,
          factura: true,
          ruc: this.ruc,
          companyName: this.razsoc,
        };
      }

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/order_tracking',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log(response.data);
          this.loading = false;
          this.removeAllProductCart();
          this.mensaje =
            'Su pedido fue solicitado correctamente, se le enviarán los detalles a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ';
          this.mensaje_error = '';
        })
        .catch(error => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.generate_order();
              })
              .catch(_ => {
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_GATEWAY) {
            console.log(error.response.data.details);
            this.loading = false;
            this.removeAllProductCart();
            this.mensaje =
              'Su pedido fue solicitado correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.mensaje_error = '';
          } else if (error.response.status === BAD_REQUEST) {
            console.log(error.response.data.details);
            this.loading = false;
            // this.removeAllProductCart();
            if (
              error.response.data.details ===
              'One or more of the selected products have no stock available'
            ) {
              this.mensaje_error =
                'Lo sentimos. Uno o más productos que usted ha solicitado ya no tienen stock disponible. ';
            } else if (
              error.response.data.details ===
              'One or more of the selected products are not available for online ordering'
            ) {
              this.mensaje_error =
                'Lo sentimos. Uno o más productos que usted ha solicitado no se encuentran disponibles para pedido online. ';
            }
            this.mensaje = '';
          } else {
            console.log(error.response.data);
            this.mensaje = '';
            this.mensaje_error =
              'Lo sentimos, se ha sucitado un error. Inténtelo nuevamente.';
            this.loading = false;
          }
        });
    },

    ocultar() {
      this.mensaje = '';
      this.mensaje_error = '';
    },
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeAllProductCart() {
      var products = [];
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.analizeCart();
    },

    //visanet methods

    visanetGetToken() {
      axios({
        method: 'post',
        //url: 'https://apitestenv.vnforapps.com/api.security/v1/security',
        url: 'https://apiprod.vnforapps.com/api.security/v1/security',
        //withCredentials: true,
        auth: {
          //username: "integraciones.visanet@necomplus.com",
          //password: "d5e7nk$M",
          username: 'info.peru@iff.com',
          password: '_vg3!$5F',
        },
      })
        .then(response => {
          console.log(response.data);
          this.visa_token = response.data;
          console.log('sesion key: ' + this.visa_token);
          localStorage.setItem('niubizSecurityToken', this.visa_token);
          this.visanetGetSesionid();
        })
        .catch(error => {
          console.log('ERROR AL HALLAR EL TOKEN DE NIUBIZ');
        });
    },

    visanetGetSesionid() {
      fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
          this.term = ip;
        });

      var json_data = {
        amount: this.totalValue,
        channel: 'web',
        antifraud: {
          clientIp: this.term,
          merchantDefineData: {
            MDD4: this.client_email,
            MDD21: 0,
            MDD31: this.cliente_phone,
            MDD32: this.client_username,
            MDD33: 'DNI',
            MDD34: this.client_dni,
            MDD75: 'Registrado',
            MDD77: '10', //se debe calcular con la fecha actual
          },
        },
      };

      console.log(
        'JSON SESION NIUNIZ CON LOS MDD: ' + JSON.stringify(json_data),
      );

      axios({
        method: 'post',
        //url: 'https://apitestenv.vnforapps.com/api.ecommerce/v2/ecommerce/token/session/456879852',
        url:
          'https://apiprod.vnforapps.com/api.ecommerce/v2/ecommerce/token/session/650178888',
        data: json_data,
        headers: {
          Authorization: this.visa_token,
        },
      })
        .then(response => {
          console.log(response.data);
          this.visa_sesion_id = response.data.sessionKey;
          console.log('sesion key: ' + this.visa_sesion_id);
          this.openVisanet();
        })
        .catch(error => {
          console.log('ERROR AL HALLAR LA SESION DE NIUBIZ');
        });
    },

    get_bank_data() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/payment_methods',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then(response => {
          console.log('responde todo bancos:' + JSON.stringify(response.data));
          this.banks_array = response.data;
        })
        .catch(error => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then(_ => {
                this.get_bank_data();
              })
              .catch(_ => {
                console.log('Error de authorization');
              });
          } else {
            toastr.error(
              error.response.data.details,
              error.response.data.message,
              {
                iconClass: 'customer-danger',
              },
            );
          }
        });
    },
  },

  created() {
    this.get_bank_data();

    console.log(
      'ATENCIONNNNNNN ESTE ES EL TOKEN QUE ENVIAREMOS PARA GUARDAR TARJETAS GAA: ' +
        this.token.substr(0, 11),
    );

    if (this.address_details == undefined) {
      this.get_delivery_detail();
    } else {
      //this.get_delivery_detail_xdistrict(this.address_details.id_district.id_district);

      if (this.dir_agency == '') {
        this.get_delivery_detail_xdistrict(
          this.address_details.id_district.id_district,
        );

        console.log('Estoy aqui: ' + this.dir_agency);
      } else {
        this.get_delivery_detail_xdistrict(
          this.transport_address_details.id_district.id_district,
        );
        console.log('Estoy aqui 2');
      }
    }
    this.analizeCart();
    this.get_puser_data();
  },

  mounted() {
    var that = this;
    window.culqi = function() {
      if (Culqi.token) {
        let tokenID = Culqi.token.id;
        let email = Culqi.token.email;
        that.generate_charge(tokenID, email);
      } else {
        console.log(Culqi.error);
      }
    };
  },
};
</script>

<style lang="scss" src="./CartFinishVisa.scss"></style>
